// React
import { ReactElement, useEffect, useState } from 'react';
// Next
import { useTranslation } from 'next-i18next';

//import { useTranslation } from 'next-i18next';
// Types
import { SexEnum } from '@utmb/types/enum/SexEnum';
import RaceRegistrationEliteView from '@utmb/types/view/RaceRegistrationEliteView';
// Styles
import styles from './start-elites.module.scss';
import { useCountry } from '@utmb/contexts/CountryContext';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import { Link } from '@utmb/design-system/link/link';
import { useRouter } from 'next/router';
import { Flag } from '@utmb/design-system/flag/Flag';

// Main Component
// noinspection JSUnusedGlobalSymbols
export const StartElitesTable = ({ race, gender, registrations }: RaceRegistrationEliteView): ReactElement => {
    const { t } = useTranslation();
    const { locale } = useRouter();
    const { countries, initCountries } = useCountry();
    const hasBib = !!registrations.find((reg) => reg.bib);
    const cat = race?.category;

    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        initCountries();
    }, []);

    return (
        <>
            <h4 className={isOpen ? styles.open : ''} role={'none'} onClick={() => setOpen(!isOpen)}>
                <div>{gender === SexEnum.WOMEN ? t('common.gender.women') : t('common.gender.men')}</div>
                <Icon color="#000" variant={IconsEnum.CHEVRON_UNCONSTRAINED} clss={styles.svg} />
            </h4>
            {isOpen && (
                <table className={styles.tableElite}>
                    <thead>
                        <tr>
                            {hasBib && <th>{t('common.bib')}</th>}
                            <th>{t('common.fullname')}</th>
                            <th>{t('singleRunner.runnerHeader.nationality')}</th>
                            <th>{t('singleRunner.runnerHeader.team')}</th>
                            {cat && (
                                <th>
                                    <PiCategoryLogo piCategory={cat} height={20} isDark={false} />
                                </th>
                            )}
                            <th>
                                <PiCategoryLogo piCategory={PiCategoryEnum.GENERAL} height={20} isDark={false} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(!registrations || registrations.length === 0) && (
                            <tr>
                                <td colSpan={5} className={styles.noResult}>
                                    {t('registeredElites.noResult')}
                                </td>
                            </tr>
                        )}
                        {registrations?.map((elite) => {
                            const nationality = countries?.find((country) => country.cio === elite.nationalityCode);
                            return (
                                <tr key={`_${race.id}_${gender}_${elite.runnerUri}`}>
                                    {hasBib && <td data-label={t('common.bib')}>{elite.bib}</td>}
                                    <td data-label={t('common.fullname')}>
                                        <Link href={`https://utmb.world/${locale}/runner/${elite.runnerUri}`}>{elite.fullname}</Link>
                                    </td>
                                    <td data-label={t('singleRunner.runnerHeader.nationality')}>
                                        {nationality && <Flag isoCode={nationality.code.toLowerCase()} hideShadow className={styles.flag} />}
                                        {nationality?.name || elite.nationalityCode}
                                    </td>
                                    <td className={styles.team} data-label={t('singleRunner.runnerHeader.team')}>
                                        {elite.sponsor?.toLowerCase() ?? ''}
                                    </td>
                                    {cat && (
                                        <td>
                                            <span>
                                                <PiCategoryLogo piCategory={cat} height={20} isDark={false} />
                                            </span>
                                            {elite.indexCat || '-'}
                                        </td>
                                    )}
                                    <td>
                                        <span>
                                            <PiCategoryLogo piCategory={PiCategoryEnum.GENERAL} height={20} isDark={false} />
                                        </span>
                                        {elite.index}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </>
    );
};
